var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVideoMixer = function SvgVideoMixer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 23"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.391 5.065c-1.234 0-2.234 1-2.234 2.234v8.67c0 1.234 1 2.234 2.234 2.234h9.537c1.233 0 2.233-1 2.233-2.234v-3.882l6.14 4.385V6.528l-6.14 4.385V7.3c0-1.233-1-2.234-2.233-2.234zM2.157 7.3c0-.681.553-1.234 1.234-1.234h9.537c.681 0 1.233.553 1.233 1.234v8.67c0 .681-.552 1.234-1.233 1.234H3.39a1.234 1.234 0 0 1-1.234-1.234zM20.3 14.53 16.06 11.5l4.24-3.028z",
    clipRule: "evenodd"
  })));
};
export default SvgVideoMixer;